module.exports = __webpack_public_path__ + "img/not_sustainable_buildings.61d8d11c.svg";